// UX audit Spec 01 — pure reader-gate decision (no network), mirroring
// viewerAccess.ts. The server (get_article_render) already decided full-vs-preview
// and returned `gated`; this maps the render flags + session to the wall state.

export type ArticleAccess =
  | { state: 'full' }
  | { state: 'needs_signin' } // anon, gated
  | { state: 'spend_prompt'; remaining: number } // metered free reader, remaining > 0
  | { state: 'out_of_reads' } // metered free reader, remaining = 0
  | { state: 'members_only' }; // members_only tier, non-member

export function decideArticleAccess(
  r: {
    gated: boolean;
    accessTier: string;
    remaining: number;
    isMember: boolean;
    unlocked: boolean;
  },
  hasSession: boolean,
): ArticleAccess {
  // Server serves full when always_free / member / (metered & unlocked) → not gated.
  if (!r.gated) return { state: 'full' };
  // Gated ⇒ non-member, not unlocked.
  if (!hasSession) return { state: 'needs_signin' };
  if (r.accessTier === 'members_only') return { state: 'members_only' };
  // metered, signed-in free reader
  if (r.remaining > 0) return { state: 'spend_prompt', remaining: r.remaining };
  return { state: 'out_of_reads' };
}
